import { writable } from 'svelte/store';
const viewportOptionsDefault = {
    isMobile: undefined,
    isTablet: undefined,
    isDesktop: undefined
};
const viewportStore = (options) => {
    return writable(options);
};
export const viewport = viewportStore(viewportOptionsDefault);
